export default "__VITE_ASSET__QnjCG8Hc__"